{
  "VALIDATION_FAILED": "Check the entered data and try again.",
  "UNAUTHENTICATED": "Please sign in to continue.",
  "FORBIDDEN": "You do not have permission to do this.",
  "NOT_FOUND": "The requested item was not found.",
  "CONFLICT": "This could not be completed because of a data conflict.",
  "UNIQUE_VIOLATION": "This value is already in use.",
  "FOREIGN_KEY_VIOLATION": "This could not be completed because other items depend on it.",
  "RATE_LIMITED": "Too many attempts. Try again shortly.",
  "IDEMPOTENCY_KEY_REUSED": "This request was already sent with different content.",
  "PAYLOAD_TOO_LARGE": "The data sent is larger than allowed.",
  "UNPROCESSABLE": "The request could not be processed.",
  "INTERNAL_ERROR": "Something unexpected happened. Try again.",
  "SERVICE_UNAVAILABLE": "The service is temporarily unavailable. Try again later.",
  "NO_PLATFORM_ACCESS": "You do not have access to this application.",
  "UA_UNAVAILABLE": "Could not reach Unified Access. Try again later.",
  "USERNAME_TAKEN": "This username is already in use.",
  "USER_ALREADY_EXISTS": "This employee is already a user of this system.",
  "CURRENCY_NOT_FOUND": "Currency was not found.",
  "CURRENCY_LOCKED": "This currency cannot be changed.",
  "VIP_NOT_ENABLED": "VIP pricing is not enabled for this currency.",
  "VIP_NOT_PERMITTED": "You do not have permission to apply VIP prices.",
  "INSUFFICIENT_BALANCE": "The box or treasury does not hold enough of this currency.",
  "HOLDER_NOT_FOUND": "The treasury or box was not found.",
  "HOLDER_ROUTE_NOT_ALLOWED": "This move is not an allowed route between treasuries and boxes.",
  "ALREADY_REVERSED": "This transaction has already been reversed.",
  "EXCHANGE_NOT_FOUND": "Exchange transaction was not found.",
  "NOTES_REQUIRED": "Notes are required when the count has a surplus or shortage.",
  "BOX_NOT_EMPTY": "The cash must be returned before this change can be made.",
  "CASHIER_NEEDS_ONE_BRANCH": "A cashier must have exactly one branch.",
  "BOX_NAME_TAKEN": "The box name is used in this branch.",
  "EMPLOYEE_NOT_ELIGIBLE": "The employee must be active, with the box's branch as the only branch.",
  "BOX_UNAVAILABLE": "The box is no longer available, choose another box.",
  "BOX_HAS_BALANCE": "A box holding a balance cannot be deactivated; return the balance first.",
  "SOLE_BOX_EMPLOYEE": "This employee is the only one in the box; add another employee or deactivate the box first.",
  "BOX_HAS_NO_EMPLOYEE": "A box without employees cannot be activated; add an employee first.",
  "SAME_CURRENCY": "Choose a different currency.",
  "IMAGE_INVALID": "The photo type or size is not accepted.",
  "IMAGE_NOT_FOUND": "The photo was not found.",
  "EXCHANGE_APP_NOT_CONFIGURED": "The exchange app is not configured on the server. Contact the administrator.",
  "TABLET_NOT_CONFIGURED": "The tablet service is not configured on the server. Contact the administrator.",
  "TABLET_UNAVAILABLE": "Could not reach the tablet service. Try again.",
  "TABLET_NOT_AVAILABLE": "This tablet is not available in this branch.",
  "TABLET_BUSY": "The tablet is busy.",
  "TABLET_REQUEST_NOT_FOUND": "The signature request was not found.",
  "TABLET_REQUEST_INVALID": "The tablet service refused the exchange details. Check the entered data and try again.",
  "SIGNATURE_NOT_SAVED": "Could not save the signature.",
  "network": "Could not reach the server. Check your internet connection.",
  "timeout": "The request timed out; the outcome is unknown.",
  "referenceId": "Reference: {{requestId}}",
  "PHONE_REQUIRED": "The phone number is required",
  "PHONE_INVALID": "The phone number is not valid",
  "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
  "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted",
  "PHONE_VERIFICATION_REQUIRED": "Verify the phone number before saving",
  "PHONE_VERIFICATION_INVALID": "The phone verification expired. Verify again",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "The phone verification expired. Verify again",
  "OTP_INVALID": "The code is incorrect",
  "OTP_EXPIRED": "The code has expired. Request a new code",
  "OTP_ATTEMPTS_EXCEEDED": "Too many wrong attempts. Request a new code",
  "OTP_RESEND_TOO_SOON": "The code cannot be resent yet",
  "OTP_SEND_LIMIT": "Too many codes were sent to this number",
  "OTP_SEND_FAILED": "The verification code could not be sent by WhatsApp. Nothing was saved. Try again, or an administrator can turn verification off in the settings",
  "OTP_ALREADY_VERIFIED": "The phone number has been verified",
  "OTP_ALREADY_CONSUMED": "The code has expired. Request a new code",
  "OTP_BINDING_MISMATCH": "The code has expired. Request a new code",
  "OTP_NOT_VERIFIED": "Verify the phone number before saving",
  "OTP_CONSUME_WINDOW_PASSED": "The code has expired. Request a new code",
  "CUSTOMERS_UNAVAILABLE": "The number could not be verified with the Customers system. Nothing was saved. Try again",
  "IDEMPOTENCY_CONFLICT": "This request number was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PHONE_VERIFICATION_NOT_ALLOWED": "Check the entered data and try again."
}
